/**
 * Bridge Session Page
 * Page wrapper that provides BridgeSessionContext and renders BridgeSessionLayout.
 * @feature BRIDGE_SESSION_FLOW - Guided session UI: domains → entropy → Bridge Card → Control Bridge
 */

import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { BridgeSessionProvider } from '../../contexts/BridgeSessionContext';
import { BridgeSessionLayout } from '../../components/BridgeSession/BridgeSessionLayout';
import type { BridgeSessionStep } from '../../types/bridgeSession';
import styles from './BridgeSessionPage.module.css';

const VALID_STEP_PARAMS: BridgeSessionStep[] = ['questions', 'domain_builder', 'entropy_heat_map', 'friction_priorities', 'define_conditions', 'bridge_card', 'control_bridge'];

export const BridgeSessionPage: React.FC = () => {
  const { sessionId } = useParams<{ sessionId?: string }>();
  const [searchParams] = useSearchParams();
  const stepParam = searchParams.get('step');
  const initialStep: BridgeSessionStep | undefined =
    stepParam && (VALID_STEP_PARAMS as string[]).includes(stepParam)
      ? (stepParam as BridgeSessionStep)
      : undefined;

  return (
    <BridgeSessionProvider initialSessionId={sessionId} initialStep={initialStep}>
      <div className={styles.bridgeSessionPage}>
        <BridgeSessionLayout sessionId={sessionId} />
      </div>
    </BridgeSessionProvider>
  );
};

export default BridgeSessionPage;
